<template>
  <div class="fb fb-main-between">
    <div
      class="common-date fb fb-main-between item-flex-1"
      :class="{ 'common-date-border': showBorder }"
    >
      <span class="font-28" @click="handlerToSelectDate"
        >{{ computedDate }}&nbsp;&nbsp;{{ week }}&nbsp;&nbsp;<i
          class="iconfont c-171A1D font-24"
          >&#xe681;</i
        ></span
      >
      <span v-if="!dateOnly">
        <i class="c-006AFE" @click="monthTotal">月统计</i>
      </span>
    </div>
    <!-- 报表 -->
    <div
      class="c-171A1D font-28 text-right fb fb-cross-center fb-main-end pr-16"
      v-if="showToReports"
    >
      <span @click="handlerJumpReportsPage">
        <i class="iconfont mr-4 font-34">&#xe6a9;</i>报表
      </span>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/comUtils'
import { WEEK_DAY } from '@/utils/constUtils'

export default {
  name: 'commonTime',
  components: {},
  props: {
    value: String,
    isHeadmaster: {
      type: Boolean,
      default: false
    },
    dingDeptIds: {
      type: String,
      default: ''
    },
    dateOnly: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showToReports: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: '',
      week: ''
    }
  },
  computed: {
    computedDate() {
      return this.date.replace(/-/g, '.')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        // 初始化月统计日期
        this.$store.commit('monthTime', null)
        this.methodUpdateDate(this.value)
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {},
    // 选择日期
    handlerToSelectDate() {
      this.$emit('select-date')
    },
    methodUpdateDate(date) {
      let _date = date ? new Date(date) : new Date()
      this.date = timeFormat(_date, 'YYYY-MM-DD')
      this.week = WEEK_DAY[_date.getDay()]
    },
    monthTotal() {
      // let partInfo = ''
      // if (isHeadmaster) {
      //   partInfo = {}
      // }
      let query = {
        date: this.date
        // partInfo
      }
      if (this.isHeadmaster && this.dingDeptIds) {
        query.dingDeptIds = this.dingDeptIds
      }
      this.$router.push({
        path: '/attendance/pageAttendanceMonth',
        query: query
      })
    },
    handlerJumpReportsPage() {
      this.$emit('handlerJumpReportsPage')
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.common-date {
  line-height: 48px;
}
.common-date-border {
  // border-bottom: 1px solid rgba(#191f25, 0.12);
}
</style>
